// Shared ChatDrawer bridge — registers the federated chat drawer from
// @symbo.ls/collab-features/chat into the editor's component registry.
// The workspace app picks it up through sharedLibraries
// (workspace/packages/shared is imported by workspace/packages/workspace/
// sharedLibraries.js), so this file serves both apps. Single source of
// truth.
//
// Workspace's app.js declares `ChatDrawer: {}` at root; canvas app.js
// does the same. Both resolve to the package's component via this
// re-export.

import { chat } from '../collab-features/src/index.js'

export const ChatDrawer = chat.ChatDrawer
export const ChatDrawerChannelRow = chat.ChatDrawerChannelRow
export const ChatDrawerMessage = chat.ChatDrawerMessage
export const toggleChatDrawer = chat.toggleChatDrawer
export const openChatDrawer = chat.openChatDrawer
export const closeChatDrawer = chat.closeChatDrawer
